import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
// import PerfectScrollbar from 'perfect-scrollbar';
import { NavigationService } from "../../../shared/services/navigation.service";
import { Subscription } from "rxjs";
import { JwtAuthService } from '../../services/auth/jwt-auth.service';

@Component({
  selector: 'app-sidebar-top',
  templateUrl: './sidebar-top.component.html'
})
export class SidebarTopComponent implements OnInit, OnDestroy, AfterViewInit {
  // private sidebarPS: PerfectScrollbar;
  public menuItems: any[];
  private menuItemsSub: Subscription;
  constructor(
    private navService: NavigationService,
    private jwtAuth: JwtAuthService
  ) { }

  ngOnInit() {
    this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
      const storedUser = this.jwtAuth.getUser();
      const userType = String(
        typeof storedUser === 'string'
          ? storedUser
          : storedUser?.user_type ?? this.jwtAuth.checkUserType()
      ).toLowerCase();

      this.menuItems = menuItem.filter(item => {
        if (item.type === 'icon' || item.type === 'separator') {
          return false;
        }

        if (userType === 'supplier') {
          return ['PMS', 'Sales'].includes(item.name);
        }

        if (userType === 'merchant') {
          return ['PMS', 'Sales', 'Wallet', 'Webhook'].includes(item.name);
        }

        return !['Wallet', 'Webhook'].includes(item.name);
      });
    });
  }
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.sidebarPS = new PerfectScrollbar('#sidebar-top-scroll-area', {
    //     suppressScrollX: true
    //   })
    // })
  }
  ngOnDestroy() {
    // if(this.sidebarPS) {
    //   this.sidebarPS.destroy();
    // }
    if( this.menuItemsSub ) {
      this.menuItemsSub.unsubscribe()
    }
  }

}
